import { FormType, Formula } from '../../Formula';
export class DateFormula extends Formula {
    static Matches(tree) {
        const dateFuncs = ['DATEPART', 'DATETRUNC'];
        if (tree.root.type !== 'CallExpression') {
            return false;
        }
        const callNode = tree.root;
        if (dateFuncs.indexOf(callNode.callee) === -1) {
            return false;
        }
        else if (callNode.arguments.length !== 2) {
            return false;
        }
        else if (callNode.arguments[0].type !== 'StringLiteral') {
            return false;
        }
        else if (callNode.arguments[1].type !== 'FieldLiteral') {
            return false;
        }
        return true;
    }
    constructor(tree, compiler) {
        super(tree, compiler);
        const callNode = tree.root;
        const partNode = callNode.arguments[0];
        const fieldNode = callNode.arguments[1];
        this._funcName = callNode.callee;
        this._datePart = partNode.value;
        this._fieldName = fieldNode.value;
    }
    get form() {
        return FormType.DATEFUNC;
    }
    get funcName() {
        return this._funcName;
    }
    get datePart() {
        return this._datePart;
    }
    get fieldName() {
        return this._fieldName;
    }
}
